var throttle = require('./throttle');
var debounce = require('./debounce');

module.exports = {
	throttle: throttle,
	debounce: debounce
};



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/throttle-debounce/index.js
// module id = /UU2
// module chunks = 15